import { twMerge } from "tailwind-merge";

import { usePopupStore } from "@/store/common/usePopupStore";

interface ComingSoonBtnProps {
    /** 버튼 문구 */
    label: string;
    /** 버튼 클래스 보정 (여백 등) */
    className?: string;
}

// 프로그램 페이지 공통 옥타곤 버튼.
// 피그마 규격: 버튼 높이 72px(심볼 박스 80px = 위아래 4px 모서리 여백 포함) / sm 이상 320px 고정 · sm 미만 전체 폭
// 위 여백은 버튼 사각형 기준: 모바일 20px, PC 28px
export const PROGRAM_BTN_CLASS =
    "relative m-[20px_auto_0] block h-[72px] w-full border border-black bg-black text-center font-['GongGothicMedium'] text-[20px] leading-[70px] text-white clip-path-octagon sm:max-w-[320px] xl:m-[28px_auto_0]";

/**
 * 신청 페이지가 아직 열리지 않은 프로그램용 버튼.
 * 클릭하면 공통 안내 팝업(ConfirmPop)으로 "COMING SOON / 추후 공개됩니다."를 띄운다.
 * 신청 URL이 확정되면 이 컴포넌트 대신 ProgramLinkBtn으로 교체하면 된다.
 */
export default function ComingSoonBtn({ label, className }: ComingSoonBtnProps) {
    const { setConfirmPop } = usePopupStore();

    return (
        <button
            type="button"
            className={twMerge(PROGRAM_BTN_CLASS, className)}
            onClick={() => setConfirmPop(true, "COMING SOON<br />추후 공개됩니다.", 1)}
        >
            <span>{label}</span>
            <span className="absolute left-0 top-0 border-[8px] border-black border-b-transparent border-r-transparent" />
            <span className="absolute bottom-0 left-0 border-[8px] border-black border-r-transparent border-t-transparent" />
            <span className="absolute right-0 top-0 border-[8px] border-black border-b-transparent border-l-transparent" />
            <span className="absolute bottom-0 right-0 border-[8px] border-black border-l-transparent border-t-transparent" />
        </button>
    );
}
